import { Button } from '../ui/Button';
import { Card } from '../ui/Card';

type Props = {
  title: string;
  explanation: string;
  impact: string;
  recovery: string;
  correlationId: string;
  onRetry?: () => void;
  onAIAssist?: () => void;
  supportUrl?: string;
};

export function ErrorRecoveryCard({
  title,
  explanation,
  impact,
  recovery,
  correlationId,
  onRetry,
  onAIAssist,
  supportUrl = '/support',
}: Props) {
  return (
    <Card padding="md" className="border-error-200 bg-error-50/50 dark:border-error-800 dark:bg-error-950/30">
      <div className="flex items-start gap-3">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-error-100 text-error-700 dark:bg-error-900 dark:text-error-300" aria-hidden="true">
          ✕
        </span>
        <div className="min-w-0 flex-1 space-y-3">
          <div>
            <h3 className="font-semibold text-error-800 dark:text-error-200">{title}</h3>
            <p className="mt-1 text-sm text-slate-700 dark:text-slate-300">{explanation}</p>
          </div>
          <div className="rounded-md border border-error-100 bg-white/60 p-3 text-sm dark:border-error-900 dark:bg-slate-900/60">
            <p className="font-medium text-slate-800 dark:text-slate-200">Business impact</p>
            <p className="mt-1 text-slate-600 dark:text-slate-400">{impact}</p>
          </div>
          <div>
            <p className="text-sm font-medium text-slate-800 dark:text-slate-200">Recommended recovery</p>
            <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">{recovery}</p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {onRetry && (
              <Button variant="primary" size="sm" onClick={onRetry}>
                Retry
              </Button>
            )}
            {onAIAssist && (
              <Button variant="ai" size="sm" onClick={onAIAssist}>
                Ask AI for help
              </Button>
            )}
            <a href={supportUrl} className="text-xs text-brand-600 underline underline-offset-2 hover:text-brand-700">
              Contact support
            </a>
          </div>
          <p className="font-mono text-xs text-slate-500">
            Correlation ID:{' '}
            <button
              type="button"
              className="underline hover:text-slate-700 dark:hover:text-slate-300"
              onClick={() => navigator.clipboard?.writeText(correlationId)}
              title="Copy correlation ID"
            >
              {correlationId}
            </button>
          </p>
        </div>
      </div>
    </Card>
  );
}
